var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _path, _ellipse, _path2, _path3, _ellipse2, _path4, _ellipse3, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path19, _circle7, _path20, _circle8, _path21, _circle9, _path22, _circle10, _path23, _circle11, _path24, _circle12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSubmarine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.958,
    x2: 212.962,
    xlinkHref: "#lg1",
    y1: 139.804,
    y2: 144.537
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.486,
    x2: 155.733,
    xlinkHref: "#lg2",
    y1: 98.039,
    y2: 106.292
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.17,
    x2: 156.683,
    xlinkHref: "#lg1",
    y1: 102.306,
    y2: 105.882
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.171,
    x2: 189.689,
    xlinkHref: "#lg3",
    y1: 168.601,
    y2: 210.134
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.76,
    x2: 529.708,
    xlinkHref: "#lg3",
    y1: 265.069,
    y2: 290.085
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fba5c2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#fca0ba",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#ff91a5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 486.119,
    x2: 529.513,
    xlinkHref: "#lg4",
    y1: 265.27,
    y2: 289.971
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-1 0 0 -1 907.543 433.5)",
    gradientUnits: "userSpaceOnUse",
    x1: 400.637,
    x2: 444.585,
    xlinkHref: "#lg3",
    y1: 62.298,
    y2: 87.315
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(-1 0 0 -1 907.543 433.5)",
    gradientUnits: "userSpaceOnUse",
    x1: 400.996,
    x2: 444.39,
    xlinkHref: "#lg4",
    y1: 62.499,
    y2: 87.2
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-1 0 0 1 828.217 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 332.231,
    x2: 345.039,
    xlinkHref: "#lg1",
    y1: 307.378,
    y2: 337.18
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.502,
    x2: 461.118,
    y1: 327.415,
    y2: 303.976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 462.326,
    x2: 473.144,
    xlinkHref: "#lg3",
    y1: 294.232,
    y2: 360.492
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 506.828,
    x2: 428.736,
    xlinkHref: "#lg4",
    y1: 330.313,
    y2: 312.734
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.872,
    x2: 191.746,
    xlinkHref: "#lg3",
    y1: 186.889,
    y2: 251.797
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.496,
    x2: 417.472,
    xlinkHref: "#lg3",
    y1: 245.007,
    y2: 298.582
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(1 0 0 -1 0 423.867)",
    gradientUnits: "userSpaceOnUse",
    x1: 440.496,
    x2: 417.472,
    xlinkHref: "#lg3",
    y1: 32.603,
    y2: 86.179
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.892,
    x2: 259.107,
    xlinkHref: "#lg3",
    y1: 226.732,
    y2: 453.233
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 385.769,
    x2: 433.654,
    xlinkHref: "#lg3",
    y1: 235.71,
    y2: 406.612
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.017,
    x2: 141.885,
    xlinkHref: "#lg3",
    y1: 267.813,
    y2: 426.026
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.253,
    x2: 81.397,
    xlinkHref: "#lg4",
    y1: 390.008,
    y2: 312.662
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.42,
    x2: 285.276,
    xlinkHref: "#lg4",
    y1: 366.211,
    y2: 308.805
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 270.606,
    x2: 183.585,
    xlinkHref: "#lg4",
    y1: 381.649,
    y2: 311.432
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.441,
    x2: 111.791,
    xlinkHref: "#lg1",
    y1: 279.225,
    y2: 340.092
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.465,
    x2: 105.57,
    xlinkHref: "#lg2",
    y1: 295.854,
    y2: 330.708
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 174.652,
    x2: 215.002,
    xlinkHref: "#lg1",
    y1: 279.225,
    y2: 340.092
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.676,
    x2: 208.782,
    xlinkHref: "#lg2",
    y1: 295.854,
    y2: 330.708
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.863,
    x2: 318.213,
    xlinkHref: "#lg1",
    y1: 279.225,
    y2: 340.092
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 288.887,
    x2: 311.993,
    xlinkHref: "#lg2",
    y1: 295.854,
    y2: 330.708
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.335,
    x2: 61.814,
    xlinkHref: "#lg4",
    y1: 395.385,
    y2: 373.864
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.468,
    x2: 74.709,
    xlinkHref: "#lg1",
    y1: 377.518,
    y2: 386.759
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.642,
    x2: 109.121,
    xlinkHref: "#lg4",
    y1: 399.828,
    y2: 378.307
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 112.775,
    x2: 122.016,
    xlinkHref: "#lg1",
    y1: 381.961,
    y2: 391.202
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.948,
    x2: 156.427,
    xlinkHref: "#lg4",
    y1: 405.381,
    y2: 383.86
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.082,
    x2: 169.322,
    xlinkHref: "#lg1",
    y1: 387.515,
    y2: 396.755
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.255,
    x2: 203.734,
    xlinkHref: "#lg4",
    y1: 405.381,
    y2: 383.86
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.388,
    x2: 216.629,
    xlinkHref: "#lg1",
    y1: 387.515,
    y2: 396.755
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.562,
    x2: 251.041,
    xlinkHref: "#lg4",
    y1: 399.828,
    y2: 378.307
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.695,
    x2: 263.935,
    xlinkHref: "#lg1",
    y1: 381.961,
    y2: 391.202
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.868,
    x2: 298.347,
    xlinkHref: "#lg4",
    y1: 395.385,
    y2: 373.864
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.001,
    x2: 311.242,
    xlinkHref: "#lg1",
    y1: 377.518,
    y2: 386.759
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m186.033 188.546c-5.602 0-10.142-4.54-10.142-10.142v-42.745c0-12.842-10.448-23.291-23.291-23.291-5.602 0-10.142-4.54-10.142-10.142s4.54-10.142 10.142-10.142c24.027 0 43.574 19.547 43.574 43.574v42.745c0 5.603-4.54 10.143-10.141 10.143z",
    fill: "url(#SVGID_1_)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.97,
    cy: 102.408,
    fill: "url(#SVGID_2_)",
    rx: 7.9,
    ry: 10.299
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m149.689 91.122c-.008 0-.015 0-.023 0-.927.003-1.377.687-.737 1.082 2.93 1.808 4.957 5.697 4.957 10.204s-2.027 8.396-4.957 10.204c-.64.395-.19 1.078.737 1.082h.023c4.781 0 8.657-5.053 8.657-11.286s-3.876-11.286-8.657-11.286z",
    fill: "url(#SVGID_3_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m230.61 206.851h-89.155v-23.784c0-7.555 6.124-13.679 13.679-13.679h61.798c7.555 0 13.679 6.124 13.679 13.679v23.784z",
    fill: "url(#SVGID_4_)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.333,
    cy: 271.087,
    fill: "url(#SVGID_5_)",
    rx: 11.127,
    ry: 36.511
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m496.333 234.577c-1.018 0-2.004.458-2.941 1.298 4.718 4.233 8.187 18.389 8.187 35.212s-3.469 30.98-8.187 35.212c.937.841 1.922 1.298 2.941 1.298 6.146 0 11.127-16.346 11.127-36.511s-4.982-36.509-11.127-36.509z",
    fill: "url(#SVGID_6_)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 496.333,
    cy: 365.184,
    fill: "url(#SVGID_7_)",
    rx: 11.127,
    ry: 36.511
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m496.333 401.694c1.018 0 2.004-.458 2.941-1.298-4.718-4.233-8.187-18.389-8.187-35.212s3.469-30.98 8.187-35.212c-.937-.841-1.922-1.298-2.941-1.298-6.146 0-11.127 16.346-11.127 36.511s4.981 36.509 11.127 36.509z",
    fill: "url(#SVGID_8_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m477.253 316.906c0-7.159.95-13.98 2.665-20.192.422.124.841.258 1.269.365l14.587 3.647c8.361 2.09 14.226 9.602 14.226 18.22 0 9.139-6.579 16.951-15.584 18.507l-12.179 2.104c-2.226-6.917-4.984-14.431-4.984-22.651z",
    fill: "url(#SVGID_9_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m494.416 337.453c7.642-1.32 13.519-7.151 15.129-14.47l-24.628-24.628-.335-.428-3.394-.848c-.428-.107-.846-.242-1.269-.365-1.715 6.212-2.665 13.033-2.665 20.192 0 8.221 2.758 15.734 4.984 22.651z",
    fill: "url(#SVGID_10_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m449.207 349.034v-61.798h24.591c6.141 0 11.119 4.978 11.119 11.119v39.56c0 6.141-4.978 11.119-11.119 11.119z",
    fill: "url(#SVGID_11_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m484.917 337.916v-22.021l-28.658-28.658h-7.052v61.798h24.591c6.14-.001 11.119-4.979 11.119-11.119z",
    fill: "url(#SVGID_12_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m255.699 246.667h-139.334v-37.17c0-11.807 9.571-21.378 21.378-21.378h96.579c11.806 0 21.378 9.571 21.378 21.378v37.17z",
    fill: "url(#SVGID_13_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m407.025 261.87 24.648-24.648c5.937-5.937 16.089-1.732 16.089 6.664v45.231z",
    fill: "url(#SVGID_14_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m407.025 374.401 24.648 24.648c5.937 5.937 16.089 1.732 16.089-6.664v-45.231z",
    fill: "url(#SVGID_15_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m162.698 217.393c-91.716 0-162.698 45.104-162.698 100.742s70.982 100.742 162.698 100.742c161.516 0 309.235-45.104 309.235-100.742s-147.719-100.742-309.235-100.742z",
    fill: "url(#SVGID_16_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m471.933 318.135c0 29.303-40.96 55.672-103.325 74.076-11.088-21.203-17.471-46.68-17.471-74.076s6.383-52.873 17.471-74.076c62.366 18.405 103.325 44.773 103.325 74.076z",
    fill: "url(#SVGID_17_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m89.478 318.135c0 38.593 12.657 73.359 33.292 97.767-71.601-10.871-122.77-50.519-122.77-97.767s51.169-86.895 122.77-97.767c-20.635 24.408-33.292 59.174-33.292 97.767z",
    fill: "url(#SVGID_18_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m240.794 415.362c-25.26 2.285-51.494 3.516-78.092 3.516-3.8 0-7.559-.081-11.291-.243l-75.901-75.888c-6.802-6.017-11.102-14.807-11.102-24.611 0-18.134 14.699-32.833 32.832-32.833 9.79 0 18.58 4.3 24.597 11.115z",
    fill: "url(#SVGID_19_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m409.514 377.675c-19.878 8.546-43.718 16.078-70.371 22.271l-57.2-57.2c-6.815-6.017-11.115-14.807-11.115-24.611 0-18.134 14.699-32.833 32.833-32.833 9.804 0 18.593 4.3 24.597 11.115z",
    fill: "url(#SVGID_20_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m330.529 401.893c-24.773 5.368-51.777 9.628-80.12 12.535l-71.682-71.682c-6.802-6.017-11.102-14.807-11.102-24.611 0-18.134 14.699-32.833 32.819-32.833 9.804 0 18.593 4.3 24.611 11.115z",
    fill: "url(#SVGID_21_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.236,
    cy: 318.135,
    fill: "url(#SVGID_22_)",
    r: 32.827
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.236,
    cy: 318.135,
    fill: "url(#SVGID_23_)",
    r: 18.798
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.447,
    cy: 318.135,
    fill: "url(#SVGID_24_)",
    r: 32.827
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.447,
    cy: 318.135,
    fill: "url(#SVGID_25_)",
    r: 18.798
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.658,
    cy: 318.135,
    fill: "url(#SVGID_26_)",
    r: 32.827
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.658,
    cy: 318.135,
    fill: "url(#SVGID_27_)",
    r: 18.798
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m91.419 391.12-17.547-17.547c-1.606-1.833-3.957-2.996-6.586-2.996-4.838 0-8.76 3.922-8.76 8.76 0 2.628 1.163 4.98 2.996 6.586l17.546 17.547c5.367-2.626 9.726-6.985 12.351-12.35z",
    fill: "url(#SVGID_28_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.287,
    cy: 379.337,
    fill: "url(#SVGID_29_)",
    r: 8.76
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m138.726 395.563-17.547-17.547c-1.606-1.833-3.957-2.996-6.586-2.996-4.838 0-8.76 3.922-8.76 8.76 0 2.628 1.163 4.98 2.996 6.586l17.546 17.547c5.367-2.626 9.726-6.985 12.351-12.35z",
    fill: "url(#SVGID_30_)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.593,
    cy: 383.78,
    fill: "url(#SVGID_31_)",
    r: 8.76
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m186.032 401.116-17.547-17.547c-1.606-1.833-3.957-2.996-6.586-2.996-4.838 0-8.76 3.922-8.76 8.76 0 2.628 1.163 4.98 2.996 6.586l17.546 17.547c5.367-2.625 9.727-6.985 12.351-12.35z",
    fill: "url(#SVGID_32_)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 161.9,
    cy: 389.333,
    fill: "url(#SVGID_33_)",
    r: 8.76
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m233.339 401.116-17.547-17.547c-1.606-1.833-3.957-2.996-6.586-2.996-4.838 0-8.76 3.922-8.76 8.76 0 2.628 1.163 4.98 2.996 6.586l17.546 17.547c5.367-2.625 9.726-6.985 12.351-12.35z",
    fill: "url(#SVGID_34_)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 209.207,
    cy: 389.333,
    fill: "url(#SVGID_35_)",
    r: 8.76
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m280.645 395.563-17.547-17.547c-1.606-1.833-3.957-2.996-6.586-2.996-4.838 0-8.76 3.922-8.76 8.76 0 2.628 1.163 4.98 2.996 6.586l17.546 17.547c5.367-2.626 9.727-6.985 12.351-12.35z",
    fill: "url(#SVGID_36_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.513,
    cy: 383.78,
    fill: "url(#SVGID_37_)",
    r: 8.76
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m327.952 391.12-17.547-17.547c-1.606-1.833-3.957-2.996-6.586-2.996-4.838 0-8.76 3.922-8.76 8.76 0 2.628 1.163 4.98 2.996 6.586l17.546 17.547c5.367-2.626 9.727-6.985 12.351-12.35z",
    fill: "url(#SVGID_38_)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 303.82,
    cy: 379.337,
    fill: "url(#SVGID_39_)",
    r: 8.76
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubmarine);
export default __webpack_public_path__ + "static/media/icon-submarine.4d301efdcbf5effaef00211156f3a011.svg";
export { ForwardRef as ReactComponent };